var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTransporter = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e374d",
    d: "M1 4v14h2.1a2.642 2.642 0 0 0 5.125 0h5.542a2.642 2.642 0 0 0 5.133 0H21v-6.937l-.187-.208-4-4-.213-.188H13V4zm1.333 1.333h9.333v11.334H8.229a2.642 2.642 0 0 0-5.125 0h-.771zM13 8h3.042l3.625 3.625v5.042H18.9a2.642 2.642 0 0 0-5.125 0H13zm-7.333 8a1.333 1.333 0 1 1-1.333 1.333A1.323 1.323 0 0 1 5.667 16zm10.667 0A1.333 1.333 0 1 1 15 17.333 1.323 1.323 0 0 1 16.333 16z",
    transform: "translate(-1 -4)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransporter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transporter.44670978.svg";
export { ForwardRef as ReactComponent };